import React from "react";
import Logo from '@/assets/images/logo.svg';
import { $t } from "./i18n";

const Footer = ({ message = {} }) => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <a className="logo-group" href="/">
            <img className="logo" src={Logo} alt="Shopee Logo" />
          </a>
          <p className="text">{$t(message.follow)}</p>
          <div className="social">
            <a
              href="https://www.facebook.com/shopeecareers/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require('@/assets/images/icon-facebook.svg')}
                className="icon"
                alt="facebook"
              ></img>
            </a>
            <a
              href="https://www.instagram.com/LifeatShopee"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require('@/assets/images/icon-instagram.svg')}
                className="icon"
                alt="instagram"
              ></img>
            </a>
            <a
              href="https://linkedin.com/company/shopee"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require('@/assets/images/icon-linkedin.svg')}
                className="icon"
                alt="linkedin"
              ></img>
            </a>
          </div>
        </div>
        {
          (message.links || []).map((links, index) => (
            <div className="col-md-2 links" key={index}>
              {
                links.map(link => (
                  <a 
                    className="footer-link" 
                    href={link.href}
                    target={link.target ? link.target : '_self'}
                    rel={link.target ? 'noopener noreferrer' : ''}
                    key={link.text}
                  >
                    {$t(link.text)}
                  </a>
                ))
              }
            </div>
          ))
        }
      </div>
      <div className="copyright">
        Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved. | <a href={message.tc} target="_blank" rel="noopener noreferrer">Terms of Service</a> | <a href={message.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </div>
    </div>
  </footer>
);

export default Footer;
